/**
 * Validation types
 */
import onlyWordsRegex from './only-words'
import passwordRegex from './password'
import eanRegex from './ean'
import dateNLRegex from './date-nl'
import emailRegex from './email'
import phoneRegex from './phone'
import zipCode from './zipcode'
import houseNumberRegex from './house-number'
import houseNumberAdditionRegex from './house-number-addition'
import names from './names'
import cdRegex from './cd'
import pecRegex from './pec'
import addressRegex from './address'

export default {
  dateNLRegex,
  eanRegex,
  emailRegex,
  houseNumberRegex,
  houseNumberAdditionRegex,
  names,
  onlyWordsRegex,
  passwordRegex,
  phoneRegex,
  zipCode,
  cdRegex,
  pecRegex,
  addressRegex
}
